import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { FaQuoteLeft } from 'react-icons/fa';

import {
  fetchTestimonialsApi,
  fetchCastingDirectorsApi,
} from '../services/api';

import './TestimonialAndDirectors.css';

const TestimonialAndDirectors = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [castingDirectors, setCastingDirectors] = useState([]);

  useEffect(() => {
    loadTestimonials();
    loadCastingDirectors();
  }, []);

  const loadTestimonials = async () => {
    try {
      const res = await fetchTestimonialsApi();
      setTestimonials(res.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const loadCastingDirectors = async () => {
    try {
      const res = await fetchCastingDirectorsApi();
      setCastingDirectors(res.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const testimonialSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  const directorSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="testimonial-wrapper testimonial-section">
      <div className="container-fluid">
        <div className="row g-5">

          {/* ================= TESTIMONIALS ================= */}

          <div className="col-12 col-lg-6">
            <div className="testimonial-card">
              <div className="testimonial-card-body">

                <h2 className="testimonial-heading">
                  Success <span>Stories</span>
                </h2>

                <Slider {...testimonialSettings}>
                  {testimonials.map((item) => (
                    <div
                      key={item.id}
                      className="testimonial-slide"
                    >
                      <FaQuoteLeft className="quote-icon" />

                      <p className="testimonial-text">
                        "{item.description}"
                      </p>

                      <div className="testimonial-user">
                        <img
                          src={`https://ui-avatars.com/api/?name=${item.name}&background=E50914&color=fff`}
                          alt={item.name}
                          className="testimonial-avatar"
                        />

                        <h5 className="testimonial-name">
                          {item.name}
                        </h5>

                        <span className="testimonial-role">
                          {item.talent_name}
                        </span>
                      </div>
                    </div>
                  ))}
                </Slider>

              </div>
            </div>
          </div>

          {/* ================= DIRECTORS ================= */}

          <div className="col-12 col-lg-6">
            <div className="director-card">
              <div className="director-card-body">

                <h2 className="testimonial-heading">
                  Popular <span>Casting Directors</span>
                </h2>

                <Slider {...directorSettings}>
                  {castingDirectors.map((director) => (
                    <div
                      key={director.id}
                      className="director-slide"
                    >
                      <div className="director-box">

                        <div className="director-image-box">
                          <img
                            src={
                              director.profile_image_url
                                ? `${process.env.REACT_APP_API_URL.replace(
                                    '/api',
                                    ''
                                  )}/uploads/${director.profile_image_url}`
                                : `https://ui-avatars.com/api/?name=${director.full_name}&background=E50914&color=fff`
                            }
                            alt={director.full_name}
                            className="director-image"
                          />
                        </div>

                        <h5 className="director-name">
                          {director.full_name}
                        </h5>

                      </div>
                    </div>
                  ))}
                </Slider>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TestimonialAndDirectors;